import { render, staticRenderFns } from "./GenerateResolutionListView.vue?vue&type=template&id=c1b17f98&scoped=true"
import script from "./GenerateResolutionListView.vue?vue&type=script&lang=js"
export * from "./GenerateResolutionListView.vue?vue&type=script&lang=js"
import style0 from "./GenerateResolutionListView.vue?vue&type=style&index=0&id=c1b17f98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b17f98",
  null
  
)

export default component.exports